import React, { useState, useEffect } from "react";
import "../../assets/css/LicenseManagement.css";
import { CommonDialogV2 } from "../common/CommonComponents/Dialog";
import { DialogActions, InputAdornment } from "@material-ui/core";
import axios from "axios";
import GenWiz from "../common/Popups/Genwizui";
import {
  StyledSearchBarPlatforms,
  StyledSearchIcon,
} from "../fui/FuiStyles";
import { he, tr } from "date-fns/locale";
import { AcceptButton2 } from "../common/CommonComponents/Buttons";
import { InputBox } from "../common/CommonComponents/InputBox";
// import { fetchExternalClientDetails } from "../../redux/fui";
import { connect } from "react-redux";
import base from "../../config";
const OrderNoSapId = () => {

  const [orderList, setOrderList] = useState([]);
  const [updateSap, setUpdateSap] = useState(false);
  const [sapID, setSapID] = useState("");
  const [sapInvalid, setSapInvalid] = useState(true)
  const [currentItem, setCurrentItem] = useState({});

  const [licenseData, setLicenseData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [sortByCustomerNameAsc, setSortByCustomerNameAsc] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const [gwconfig, setgenwiz] = useState({ stateFunction: setgenwiz });

  const onload = () => {
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Fetching Data',
      }
    });
    const idToken = localStorage.getItem("token");

    if (idToken === null || idToken === undefined) {
      window.location.href = "/"
      return false;
    }
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    const urls = `${base.app.apiSite}order/no-sap-contract-data`
    axios
      .get(urls, urloptions)
      .then((response) => {
        setOrderList(response.data['orders']);
        setIsLoading(false);
        setgenwiz({});
      })
      .catch((error) => {
        console.error("Error fetching license data:", error)
        setIsLoading(false);
      });
  };

  const updatContracId = () => {
    const idToken = localStorage.getItem("token");
    setgenwiz({
      appName: 'gwLoading',
      config: {
        stateFunction: setgenwiz,
        text: 'Updating Contract ID',
      }
    });

    if (idToken === null || idToken === undefined) {
      window.location.href = "/"
      return false;
    }
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    const postData = {
      orderItemUId: currentItem.OrderItemUId,
      sapContractId: sapID
    }
    const urls = `${base.app.apiSite}order/no-sap-contract-data`
    //close the pop up
    setUpdateSap(false);
    axios.post(urls,
      postData, urloptions
    ).then((resp) => {
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Update Success',
          callback: () => {
            setUpdateSap(false);
            setSapID("");
            onload();
          }
        }
      });

    }).catch((error) => {
      console.error("Error fetching license data:", error);
      setUpdateSap(false);
      setSapID("");
      setgenwiz({
        appName: 'gwAlert',
        config: {
          stateFunction: setgenwiz,
          text: 'Update Failed',
        }
      });
    }
    );
  };

  useEffect(() => {
    onload();
  }, []);

  const hideTMenu = () => {
    const alldiv = document.getElementsByClassName('table-menu');
    for (var i = 0, len = alldiv.length; i < len; i++) {
      alldiv[i].style["display"] = 'none';
    }
  };

  const tableButton = (evt) => {
    evt.stopPropagation();
    const curdiv = evt.target.closest("td").querySelector(".table-menu");
    if (curdiv.style.display === "block") {
      curdiv.style.display = "none";
    } else {
      const alldiv = document.getElementsByClassName("table-menu");
      for (let i = 0; i < alldiv.length; i++) alldiv[i].style.display = "none";
      curdiv.style.display = "block";
    }
  };

  const filteredLicenses = licenseData
    .filter((license) => {
      const query = searchQuery.toLowerCase();
      return (
        license.id.toString().includes(query) ||
        (license.customer_name && license.customer_name.toLowerCase().includes(query)) ||
        (license.sap_contract_id && license.sap_contract_id.toLowerCase().includes(query))
      );
    })
    .sort(function (a, b) {
      var nameA = (a.customer_name && a.customer_name.toLowerCase()) || "";
      var nameB = (b.customer_name && b.customer_name.toLowerCase()) || "";
      if (nameA < nameB) return sortByCustomerNameAsc ? -1 : 1;
      if (nameA > nameB) return sortByCustomerNameAsc ? 1 : -1;
      return 0;
    });

  const checkSap = (event) => {
     const inpValue = event.target.value;
    let sapLength = inpValue.length
    // if (sapLength > 10)
    //   return false;

    // if (sapLength === 10) {
    //   fetchExternalClientDetails(inpValue);
    // } else {
    //   setSapInvalid(true);
    // }
    const regex = /^\d+$/;
    if(inpValue!== ""){
      if (regex.test(event.target.value) === false)
        return false;
    }
    
    
    if (sapLength < 10)
      setSapInvalid(true);
    
    if (sapLength >= 10)
      setSapInvalid(false)
      
    setSapID(inpValue);
  }

  const fetchExternalClientDetails = async (contractCode) => {
    const idToken = localStorage.getItem("token");
    const urloptions = {
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "Authorization": idToken,
      }
    };
    const urls = `${base.app.apiSite}fui/client-details`
    await axios
      .get(urls, {
        ...urloptions,
        params: {
          contract_code: contractCode,
        },
      })
      .then((resp) => {
        if (resp.data[0] !== 'N/A') {
          setSapInvalid(false);
        }
        else {
          document.getElementById('saperror').innerText = "Invalid Contract ID"
        }
      })
      .catch((err) => {
        console.log(err)
      });
  };


  const totalPages = Math.ceil(filteredLicenses.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedLicenses = filteredLicenses.slice(startIndex, endIndex);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", alignItems: 'center', padding: "0px 10px", position: 'relative' }} onClick={()=>hideTMenu()}>
        <div style={{position:'absolute',left:'10px'}}>
          <h3 style={{color:'#555555',fontWeight:'500'}}>Order Follow UP</h3>
        </div>

        <StyledSearchBarPlatforms
          value={searchQuery}
          onChange={(e) => { }}
          id="outlined-search"
          type="search"
          margin="normal"
          placeholder="Search filter"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <StyledSearchIcon />
              </InputAdornment>
            ),
          }}
          style={{ borderRadius: '30px' }}
        />
      </div>

      <table className="licensedata">
        <thead>
          <tr>
            <th>Order UID</th>
            <th>
              Enterprise ID
            </th>
            <th>Created By</th>
            <th>Request Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            Array.from({ length: 10 }).map((_, i) => (
              <tr key={i} className={'skeleton'}>
                {Array.from({ length: 5 }).map((_, j) => (
                  <td key={j}><span>0000000000</span></td>
                ))}
              </tr>
            ))
          ) :
            <>
              {
                orderList.length !== 0 ?
                  <>
                    {
                      orderList.map((order, index) => (
                        <tr key={index}>
                          <td>{order.OrderItemUId}</td>
                          <td>{order.Pocdetails}</td>
                          <td>{order.CreatedBy}</td>
                          <td>{order.CreatedDate}</td>
                          <td>
                            <button type="button" onClick={(evt) => tableButton(evt)}></button>
                            <div className="table-menu" style={{ display: "none" }}>
                              <div className="tri"></div>
                              <ul>
                                <li onClick={() => { hideTMenu(); setCurrentItem(order); setUpdateSap(true) }}>Update SAP ID</li>
                                <li style={{ color: '#EBEBEB' }}>Stopped</li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))
                    }
                  </>
                  :
                  <>
                    <tr>
                      <td colSpan={9} rowSpan={5} style={{ textAlign: 'center' }}>No Data Found</td>
                    </tr>
                  </>
              }
            </>
          }
        </tbody>
      </table>
      {/* GenWiz Spinner */}
      {updateSap && (
        <InputBox
          open={updateSap}
          onClose={() => { setSapID(""); setSapInvalid(true); setUpdateSap(false) }}
          title={""}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>Enter your SAP Contract ID</div>
              <div style={{ margin: '10px 0', textAlign: 'center' }}>
                <input onChange={(e) => checkSap(e)}
                  maxLength={15}
                  value={sapID}
                  type="text" placeholder="SAP ID" style={{ width: 'calc(100% - 20px)', padding: '10px 10px', fontSize: '1rem', border: '1px solid #EBEBEB', borderRadius: '5px', margin: '0 0 10px 0' }} />
                {(sapInvalid && sapID !== "" && sapID.length === 10) &&
                  <label id="saperror" style={{ margin: '10px 0 0 0', color: '#c20000', textAlign: 'center', fontSize: '.9em' }}>Validating</label>
                }
              </div>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 id="sapUpdateButton" label={"Update"} onClick={() => updatContracId()} disabled={sapInvalid} />
              <AcceptButton2 label={"Cancel"} onClick={() => { setSapID(""); setSapInvalid(true); setUpdateSap(false) }} />
            </DialogActions>
          }
          width={'300px'}
        ></InputBox>
      )}
      <GenWiz open={true} appconfig={gwconfig} />
    </>
  );
};

export default OrderNoSapId;
